import { useContext } from 'react';
import { Box, Flex, LoadingOverlay, Paper, Space } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import SkeletonItems, { EmptyListSkeleton } from '../../Atoms/SkeletonItems';
import PaginationNav from '../../Molecules/Navigation/PaginationNav';
import EmailMasterDetail from '../../Templates/Emails/EmailMasterDetail';
import ChatMessage from '../../Molecules/Message/ChatMessage';
import { MessageContext } from '../../Service/Context/MessageContextV2';
import ChatMessagePreview from './ChatMessagePreview';
import NewEmail from './NewEmail';
import EmailRowPhone from './EmailRowPhone';
import EmailsListHeader from './EmailsListHeader';
import ReplyMessagePreview from './ReplyMessagePreview';

const EmailsSection = () => {
  const { loading, messages, pageNumber, pageCount, totalCount, setPageNumber, selectedMessage } =
    useContext(EmailBoxContext);
  const { preparingMessage } = useContext(MessageContext);
  const isDesktop = useMediaQuery('(min-width: 1200px)');
  const emptyBox = messages.length === 0;

  return (
    <Box pos="relative">
      <LoadingOverlay visible={preparingMessage} overlayBlur={2} loaderProps={{ size: 'xl' }} />
      {isDesktop ? (
        <DesktopSection />
      ) : (
        <>
          <EmailsListHeader phoneVersion />
          <Space h="sm" />
          {!selectedMessage && (
            <>
              {loading && <SkeletonItems count={8} height={80} />}
              <Paper>{!loading && messages.map((email) => <EmailRowPhone key={email.id} email={email} />)}</Paper>
              {emptyBox && <EmptyListSkeleton />}
            </>
          )}
          {selectedMessage && (
            <Paper radius="md">
              <ChatMessage phoneVersion />
            </Paper>
          )}
          {!selectedMessage && !emptyBox && (
            <PaginationNav
              pageSize={10}
              pageNumber={pageNumber}
              totalCount={totalCount}
              totalPages={pageCount}
              onChange={(newPageNumber) => setPageNumber(newPageNumber - 1)}
              entityName="Nachricht"
            />
          )}
        </>
      )}
    </Box>
  );
};

const DesktopSection = () => {
  const { action } = useContext(MessageContext);
  const replying = action === 'REPLY';

  return (
    <Flex gap="xs" sx={{ alignItems: 'flex-start' }}>
      <Box
        sx={(theme) => ({
          minWidth: 300,
          maxWidth: 325,
          border: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[1]}`,
          borderRadius: 10,
        })}
      >
        <EmailMasterDetail />
      </Box>
      <Box
        sx={(theme) => ({
          border: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[1]}`,
          borderRadius: 10,
          flexGrow: 1,
          minHeight: 500,
        })}
        pos="relative"
      >
        <NewEmail />
        <ChatMessagePreview />
        {replying && <ReplyMessagePreview withPadding />}
      </Box>
    </Flex>
  );
};

export default EmailsSection;
